import { getApolloClient } from 'owa-apollo';
import { ApplyConversationActionContext } from 'owa-mail-triage-action-utils';
import getEwsRequestDateString from 'owa-mail-triage-action-utils/lib/getEwsRequestDateString';
import {
    UndoDeleteConversationDocument,
    UndoDeleteConversationMutation,
} from './graphql/__generated__/undoDeleteConversationMutation.interface';

type UndoDeleteConversationResult = UndoDeleteConversationMutation['undoDeleteConversation'];

/**
 * Restore message service
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @param undoRequestId requestId for undo needed in case of Hx
 * @return the ApplyConversationActionResponseMessage
 */
export default async function restoreConversationService(
    conversationContexts: ApplyConversationActionContext[],
    folderId: string,
    undoRequestId?: number
): Promise<UndoDeleteConversationResult> {
    const conversationSnapShots = conversationContexts.map(context => {
        return {
            id: context.conversationId,
            messagesAsOf: getEwsRequestDateString(context.conversationLastSyncTimeStamp),
        };
    });
    const client = await getApolloClient();
    const result = await client.mutate({
        variables: {
            conversations: conversationSnapShots,
            folderId: folderId,
            undoRequestId: undoRequestId,
        },
        mutation: UndoDeleteConversationDocument,
    });

    return result?.data?.undoDeleteConversation;
}
